import styled from '@emotion/styled'
import { Typography, TextStylePreset, Button } from '@vivaldis/antd-ui'
import { Edit } from '@vivaldis/icons'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { EmployeeProfileQuery_employee } from '../../typings/EmployeeProfileQuery'
import { IdCard } from './components/IdCard'
import { MainInfo } from './components/MainInfo'
import { ResidencePermit } from './components/ResidencePermit'
import { SuperUserInfo } from './components/SuperUserInfo'
import { WorkPermit } from './components/WorkPermit'
import { Information } from '../../../Information'

export interface EmployeeProfileProps {
  employee: EmployeeProfileQuery_employee
  onRefreshRemainingHours?: () => Promise<void>
}

export const PersonalInformation: FC<EmployeeProfileProps> = ({
  employee,
  onRefreshRemainingHours
}) => {
  const [t] = useTranslation('web_ui')

  return (
    <>
      <Base>
        <Typography.Paragraph
          preset={TextStylePreset.Semibold16}
          marginBottom={0}
        >
          {t('employee_profile.personal_information_header')}
        </Typography.Paragraph>
        <Button
          to={`/employee/${employee.id}/edit-employee-personal-information`}
          openInSideSheet
          type="default"
          icon={<Edit />}
        >
          {t('employee_profile.edit_personal_information_button')}
        </Button>
      </Base>
      <Information>
        <SuperUserInfo
          employee={employee}
          onRefreshRemainingHours={onRefreshRemainingHours}
        />
        <MainInfo employee={employee} />
        <IdCard employee={employee} />
        <ResidencePermit employee={employee} />
        <WorkPermit employee={employee} />
      </Information>
    </>
  )
}

const Base = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 16px;
`
